module.exports = __webpack_public_path__ + "static/media/photo176.1bda2ae1.jpg";